import React, { useState } from "react";
import EdModal from "../../../generic/edModal";
import { useHistory } from "react-router-dom";
import EdButton from "../../../generic/edButton";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
import {
  CreateServiceRequestDetails,
  ServiceClientValidation,
} from "../../../service/serviceRequest/srApiService";
import Loader from "../../../generic/loader";
import { config } from "../../../../config/domain";

export const AccountReactivationConsent = (props: any) => {
  const [main, setMain] = useState<boolean>(true);
  const [block, setBlock] = useState<boolean>(false);
  const [adhar, setAdhar] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);

  const history = useHistory();
  const onSubmit = async () => {
    try {
      setLoader(true);
      const payload = {
        requestType: "Account Reactivation",
        dpID: "None",
      };
      const serviceList = await asyncGetServiceRequest();
      let response = await ServiceClientValidation({
        subType: "Equity Dormant Reactivation",
      });
      const sr = serviceList.filter(
        (srReq: any) =>
          srReq.RequestType === "Equity Dormant Reactivation" &&
          [
            "Draft Saved",
            "Submitted",
            "AssignedtoHO",
            "InProcess",
            "PendingforEsign",
            "EsignVerified",
            "EsignSubmitted",
            "AssignedforEsignQC",
            "EsignVerified",
            "PushToTarget",
            "MemorandumPaymentPending",
          ].includes(srReq.RequestStatus)
      )[0];
      if (response === "BOAcoountNumber not found") {
        const accReact = await CreateServiceRequestDetails(payload);
        if (
          typeof accReact === "string" &&
          accReact.includes(
            "Previous Request already open for this account-"
          )

        ) {
          setLoader(false);
          setError(true);
          return;
        }
        
        if (accReact && accReact.Message)
          localStorage.setItem(
            "accReactParentDetails",
            JSON.stringify(accReact)
          );
        else {
          setLoader(false);
          setError(true);
          return;
        }
      } else {
        if (sr)
          localStorage.setItem("accReactParentDetails", JSON.stringify(sr));
      }
      setLoader(false);
      setModal(false);
      const consent = props ? (props.type ? props.type : null) : null;
      history.push(
        `/clientarea/service-request/account-reactivation${
          consent ? `?consent=${consent}` : ""
        }`
      );
    } catch (err) {
      // console.log(err);
      setLoader(false);
      setError(true);
    }
  };

  function ModalBody(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn income-declaration-phase1">
        <div className="modal-content">
          {loader ? (
            <div
              style={{
                textAlign: "center",
                paddingTop: "50px",
                paddingBottom: "50px",
              }}
            >
              <Loader size={50} color="blue"></Loader>
            </div>
          ) : (
            <div className="modal-body">
              {main && (
                <div className="finalScreen consentPopup reactivateAccPopup">
                  <div className="inProgress_wrap">
                    <div className="inProgress icon_wrap_blue">
                      <i className="edel-icon-refresh"></i>
                    </div>
                  </div>
                  <div>
                    <p className="field-head text-center">
                      {" "}
                      Reactivate Your Account
                    </p>
                  </div>
                  <div>
                    <p className="field-subHead desc text-center">
                      As per SEBI norms your account has been deactivated due to
                      inactivity. Please follow a few simple steps to reactivate
                      your account.
                    </p>
                  </div>
                  <div className="btn_links reactivatePopup">
                    <div>
                      <EdButton
                        className="ed_button button submit_btn primary_border active"
                        onClick={() => onSubmit()}
                        value="Proceed"
                        btnTyp="primary"
                        // disabled={btn}
                      />
                    </div>
                    <div>
                      <button
                        className="ed_button button submit_btn primary_border no-border"
                        onClick={() => {
                          setMain(false);
                          setBlock(true);
                        }}
                      >
                        Remind me later
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {block && (
                <div className="finalScreen consentPopup">
                  <div>
                    <a
                      role="button"
                      href={config.root}
                      //onClick={props.onClose}
                      title="Close"
                      className="exclamateConsent-cancel"
                    >
                      <i
                        className="edel-icon-close"
                        style={{ float: "right" }}
                      ></i>
                    </a>
                  </div>
                  <div className="">
                    <div className="icon-wrap">
                      <i className="edel-icon-blocked"></i>
                    </div>
                  </div>
                  <div>
                    <p className="field-head text-center">Account blocked</p>
                  </div>
                  <div className="rectivateAcct">
                    <p className="field-subHead desc text-center grey-text">
                      In order to do trades in your account, please complete
                      your reactivation process. You will be notified again in
                      your next login.
                    </p>
                  </div>
                </div>
              )}
              {error && (
                <div className="finalScreen consentPopup">
                  <div className="">
                    <div className="icon-wrap">
                      <i className="edel-icon-blocked"></i>
                    </div>
                  </div>
                  <div>
                    <p className="field-head text-center">Technical Issue</p>
                  </div>
                  <div>
                    <p className="field-subHead desc text-center grey-text">
                      Facing Some Technical Issue.Please Try Again Later.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  function AdharModalBody(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn income-declaration-phase1">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <div className="finalScreen consentPopup panAdharLink">
                <div className="inProgress_wrap">
                  <div className="inProgress icon_wrap_blue">
                    <i className="edel-icon-link-icon"></i>
                  </div>
                </div>
                <div>
                  <p className="field-head text-center">Link PAN & Aadhar</p>
                </div>
                <div>
                  <p className="field-subHead desc text-center">
                    As per SEBI norms your PAN and Aadhaar need to be linked. In
                    order to do this you will be sent to the Income Tax website.
                  </p>
                  <div className="reactivateSteps">
                    <p className="small-text">Steps to follow</p>
                    <ul>
                      <li>Login or Register on it using your PAN as user ID</li>
                      <li>
                        A pop up window will appear asking you to link PAN with
                        Aadhaar. If not, then go to “Profile Settings” in Menu
                        and click “Link Aadhaar”
                      </li>
                      <li>
                        Check and verify details. Mismatches will need to be
                        corrected independently.
                      </li>
                      <li>
                        Once details match, enter Aadhaar number, click on “Link
                        now” button.
                      </li>
                      <li>
                        Come back to www.nuvamawealth.com after 1 day and login
                        again to continue
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="">
                  <button type="button" className="common_button block_btn">
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <EdModal show={modal} close={() => {}} children={ModalBody()} />;
};
